import { useSwrNoAuth } from "../../swr/useSwrNoAuth";


export const useFetchIsExistsOverallScore = (lineAccountId: string|null) => {
  const fetcherKey = lineAccountId ? `games/roulette/line-accounts/${lineAccountId}/score/overall/exists/` : null;
  const { data: isExistsOverallScore, error, isLoading } = useSwrNoAuth<boolean>(fetcherKey)
  return { isExistsOverallScore, isLoading, error };
};